import * as moment from 'moment';
import { IPayrollsDetail } from '../interfaces/payrolls-detail.interface';

export class ValidateTimesHelper {

  public static validPickup(params: ValidateTimesHelperI): boolean {

    let minutesFinal = 0;
    let {
      time, pickup, addedon, dateofservice, currentLeg,
      minutesLegA = 15,
      minutesLegB = 30
    } = params;

    if (time.replace(/[^0-9]/g, '').length !== 4) {
      return false;
    }

    const ADDED_ON = moment(addedon);
    const DOS = moment(dateofservice);

    const dateIsSame = DOS.isSame(ADDED_ON, 'day');
    if (dateIsSame) { minutesLegA = 180; minutesLegB = 180; }

    switch (currentLeg) {
      case 'A':
        minutesFinal = minutesLegA;
        break;
      case 'B':
        minutesFinal = minutesLegB;
        break;
      default:  // Others legs.
        minutesFinal = minutesLegA;
        break;
        // return false;
    }

    const response = this.internalValidatePickup(
      this.addDateOfServiceTo(dateofservice, time),
      this.addDateOfServiceTo(dateofservice, pickup),
      minutesFinal,
    );

    return response;
  }

  public static validDropOff(params: ValidateTimesHelperI): boolean {

    let response = false;
    const {
      time, pickup, addedon, dateofservice, currentLeg,
      minutesLegA = null, minutesLegB = null,
      appointmentCurrent
    } = params;

    if (time.replace(/[^0-9]/g, '').length !== 4) {
      return false;
    }

    const ADDED_ON = moment(addedon);
    const DOS = moment(dateofservice);
    const appointment = appointmentCurrent ? appointmentCurrent : pickup;
    const dateIsSame = DOS.isSame(ADDED_ON, 'day');

    if (dateIsSame) { return false; }

    switch (currentLeg) {
      case 'A':
        response = this.internalValidateDropoff(
          this.addDateOfServiceTo(dateofservice, time),
          this.addDateOfServiceTo(dateofservice, appointment)
        );
        break;
      default:
        return false;
    }

    return response;
  }

  private static addDateOfServiceTo(dateofservice: string, time: string): string {
    return `${dateofservice} ${time}`;
  }

  private static internalValidatePickup(actualPuTime: string, pickuptime: string, minutes: number): boolean {
    const ACTUAL_PU_TIME = moment(actualPuTime).format('YYYY-MM-DD HH:mm:ss');
    const PU_TIME = moment(pickuptime).format('YYYY-MM-DD HH:mm:ss');

    if (ACTUAL_PU_TIME && PU_TIME) {
      const dateStart = moment(PU_TIME);
      const dateEnd = moment(ACTUAL_PU_TIME);
      const minAdded = moment(dateStart).add(minutes, 'minutes');
      return dateEnd.isAfter(minAdded);
    } else {
      return true;
    }
  }

  private static internalValidateDropoff(actualDoTime: string, appointment: string): boolean {
    const ACTUAL_DO_TIME = moment(actualDoTime).format('YYYY-MM-DD HH:mm:ss');
    const APPOINTMENT = moment(appointment).format('YYYY-MM-DD HH:mm:ss');

    if (ACTUAL_DO_TIME && APPOINTMENT) {
      const appointmentime = moment(APPOINTMENT);
      const adoTime = moment(ACTUAL_DO_TIME);
      return adoTime.isAfter(appointmentime);
    } else {
      return true;
    }
  }

  public static hasValidDates(data: IPayrollsDetail): boolean {
    if (!data.startdate || !data.enddate) {
      return false;
    }

    if (
      typeof data.startdate !== 'string' ||
      typeof data.enddate !== 'string'
    ) {
      return false;
    }

    const start = new Date(data.startdate.trim());
    const end = new Date(data.enddate.trim());

    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      return false;
    }

    return start <= end;
  }
}

export interface ValidateTimesHelperI {
  time: string;
  pickup: string;
  addedon: string;
  dateofservice: string;
  currentLeg: string;
  minutesLegA?: number;
  minutesLegB?: number;
  appointmentCurrent?: string; // Only For DropOff
}



// WEBPACK FOOTER //
// ./src/app/core/helpers/validate-times-helper.service.ts